import styled from "styled-components";
import { COLORS } from "../../shared";
import { MEDIA_QUERY } from "../../entities/Common";

export const BreadcrumbsStyled = styled.section`
  box-sizing: border-box;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
  }
  li {
    padding-right: 30px;
    position: relative;
    a {
      text-decoration: none;
      color: inherit;
      &:hover {
        text-decoration: underline;
      }
    }
    &::after {
      content: "";
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -0.5px;
      height: 1px;
      width: 15px;
      right: 7.5px;
      background-color: ${COLORS.PRIMARY_DARK};
    }
    &:last-child {
      padding-right: 0;
      &::after {
        content: none;
      }
    }
  }
  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    padding-top: 20px;
    ul {
      flex-wrap: wrap;
      li {
        font-size: 14px;
        a {
          font-size: 14px;
        }
      }
    }
  }
`;
